<style lang="scss">
.menu-title {
	cursor: pointer;
	user-select: none;
	padding: 2px 12px 2px 6px;
	float: unset !important;
	&:hover {
		background-color: #d5e8fc;
	}
}

.menu-node-btn {
	float: right;
	display: block;
	button {
		margin-right: 8px;
	}
}

.menu-title-active {
	background-color: #d5e8fc;
}
.product-tree .product-tree-component .menu-title-active {
    background-color: #ff9900;
}
</style>

<template>
	<div class="product-tree">
        <vInput
			class="menu-search"
			v-model="search"
			@on-enter="handleInput"
			suffix="search"
			@on-icon-click="handleInput"
			placeholder="支持code, name等搜索"
		></vInput>
		<vTree
            class="product-tree-component"
			style="min-height:70vh;"
			:data="getNodes"
			:render="renderNode"
			ref="tree"
		></vTree>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
	HttpGetCategories
} from '@/service/products/allproducts'

export default {
	data() {
		return {
            search: "",
			operateId: null,
			linkIndex: "",
			dataList:'',
			getBillcategory:[],
		}; 
	},
	created(){
		this.getcategory()
	},
	computed: {
		// ...mapGetters('dictionary', ['getBillcategory']),
		getNodes() {
			const data = this.getBillcategory
			const Nodes = [];
			data.forEach(item => {
				const parentId = item.parentId;
				if (!parentId) return Nodes.push(item);
				const parent = data.find(function (item) {
					return parentId === item.id;
				});
				if (!parent) return;
				const children = parent.children;
				if (children) {
					children.push(item);
				} else {
					parent.children = [item];
				}
			});
			Nodes.forEach((item) => {
				item.expand = true;
			})
			return Nodes;
		},
	},
	methods: {
        handleInput (val) {
            let indistinctTarget,
				target = this.getBillcategory.find(function (item) {
					if (!indistinctTarget && val && `${item.name}`.indexOf(val) > -1 && `${item.name.toLowerCase().indexOf(val.toLowerCase()) > -1}`) indistinctTarget = item;
					return val && (val == item.code || val == item.name || val == item.nameEn || item.name.toLowerCase().indexOf(val.toLowerCase()) > -1);
				}) || indistinctTarget;
            if (target) {
				this.$refs.tree.initStatus(['id', this.operateId = target.id]);
				// this.$emit('on-data', target, 'edit');
				setTimeout(() => {
					const ele = document.querySelector(`.vview-treenode-li[data-id="${this.operateId}"]`);
					ele.scrollIntoView({ block: "center" });
				}, 600)
			}
        },
		getcategory(){
			HttpGetCategories().then(res=>{
				// console.log(res)
                this.getBillcategory = res.data
			},err=>{
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			})
		},
		renderNode(h, {
			root,
			node,
			data
		}) 
		{
			let active = this.operateId === data.id;
			return h('div', {
				class: [
					'menu-title',
					{
						'menu-title-active': active
					}
				],

				// attrs: {
				// 	title: "双击编辑该节点"
				// }
			}, [data.name,
			h('span', {
				class: 'menu-node-btn'
			},
				[
					
					data.level==3 ? h('vButton', {
						props: {
							icon: 'checkmark',
							size: 'small',
						},
						// attrs: {
						// 	title: "编辑该节点"
						// },
						on: {
							click: (event) => {
								event.stopPropagation();
								this.getNode(root, node, data);
							},
						},
					}) : null,
				]
			),
				])
		},
		handleKeepStatus() {
			if (linkIndex) {
				this.$refs.tree.status = linkIndex.split(',')
			}
		},
		getNode(root, node, data) {
			// console.log(node, data)
			this.operateId = data;
			this.$emit('on-data', data, 'edit');
		},
	},
};
</script>
